import { ActionIcon, Button, FileButton, Flex, Image, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconTrash } from "@tabler/icons-react";
import React, { useState, useEffect } from "react";

export default function FileUploader({ file, setFile, title, accept, url, removeUrl }) {
  const [opened, { open, close }] = useDisclosure();
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) return;

    const isBlob = file instanceof Blob;
    if (!isBlob) {
      setPreview(file);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(file);
  }, [file]);

  return (
    <>
      {url && (
        <Flex gap="sm">
          <Button sx={{ flex: 1 }} color="teal" onClick={open}>
            {title} 보기
          </Button>
          <ActionIcon size="lg" variant="filled" color="red" sx={{ height: 36, width: 36 }} onClick={removeUrl}>
            <IconTrash size={18} />
          </ActionIcon>
        </Flex>
      )}
      {!url && file && (
        <Flex gap="sm">
          <Button sx={{ flex: 1 }} color="teal" onClick={open}>
            {title} 보기
          </Button>
          <ActionIcon
            size="lg"
            variant="filled"
            color="red"
            sx={{ height: 36, width: 36 }}
            onClick={() => setFile(null)}
          >
            <IconTrash size={18} />
          </ActionIcon>
        </Flex>
      )}
      {!url && !file && (
        <FileButton onChange={setFile} accept={accept}>
          {(props) => (
            <Button variant="default" fullWidth {...props}>
              {title}
            </Button>
          )}
        </FileButton>
      )}

      <Modal opened={opened} onClose={close} title="상세보기" size="xl" zIndex="1000">
        <Image src={preview || url} width="100%" />
        <Flex gap="sm" mt="sm" justify="flex-end">
          <Button onClick={() => window.open(url || preview)} variant="default">
            새 창에서 열기
          </Button>
          <Button onClick={close}>닫기</Button>
        </Flex>
      </Modal>
    </>
  );
}
